module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap1A",
      "src": "images/fig_1.jpg"
    }
  }), _vm._v(" Creation, Beauty, and Science")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap1b",
      "src": "images/fig_2.jpg"
    }
  }), _vm._v(" Emerging Adult Faith: Not an LP, but a Digital Download")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_schap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#schap-001"
    }
  }, [_vm._v("CASE STUDY:"), _c('br'), _vm._v("Addressing the New Atheism")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap1d",
      "src": "images/fig_3.jpg"
    }
  }), _vm._v(" Emerging Adults: Are They None and Done?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_schap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#schap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY:"), _c('br'), _vm._v("Cognitive Science and Reasons Not to Believe")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap1f",
      "src": "images/fig_4.jpg"
    }
  }), _vm._v(" On a Crash Course with Hermeneutics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_schap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#schap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO CASE STUDIES:"), _c('br'), _vm._v("Making Too Much of a Good Thing: Big Bang and Fine-Tuning")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap1hh",
      "src": "images/fig_5.jpg"
    }
  }), _vm._v(" Adam, Eve, and History")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_schap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#schap-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY:"), _c('br'), _vm._v("What About Intelligent Design? Where’s Your ID?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap1h",
      "src": "images/fig_6.jpg"
    }
  }), _vm._v(" Calling Out the Good in Technology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap1i",
      "src": "images/fig_7.jpg"
    }
  }), _vm._v(" Give Technology a Break")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_schap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#schap-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO CASE STUDIES:"), _c('br'), _vm._v("On Global Climate Change and Sexuality (Where We’re Tempted to Ask Science for Things It Can’t Deliver)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap1j",
      "src": "images/fig_8.jpg"
    }
  }), _vm._v(" Moving Forward")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Mere Science and Christian Faith")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0